export enum AuthEvents {
    SIGNED_IN = 'signedIn',
    SIGN_IN_WITH_REDIRECT = 'signInWithRedirect',
    SIGN_IN_WITH_REDIRECT_FAILURE = 'signInWithRedirect_failure',
    TOKEN_REFRESH = 'tokenRefresh',
    SIGNED_OUT = 'signedOut',
    CUSTOM_OAUTH_STATE = 'customOAuthState',
}

export enum AuthTab {
    LOGIN = 'login',
    SIGNUP = 'signup',
}
